<template>
  <div class="app-container">
    <!-- begin app-main -->
    <div class="app-main" id="main">
      <!-- begin container-fluid -->
      <div class="container-fluid">
        <!-- begin row -->
        <div class="row">
          <div class="col-md-12 m-b-30">
            <!-- begin page title -->
            <div class="d-block d-sm-flex flex-nowrap align-items-center">
              <div class="page-title mb-2 mb-sm-0">
                <h1>Airtime Networks</h1>
              </div>
              <div class="ml-auto d-flex align-items-center">
                <nav>
                  <ol class="breadcrumb p-0 m-b-0">
                    <li class="breadcrumb-item">
                      <a>
                        <i class="ti ti-home"></i>
                      </a>
                    </li>
                    <li class="breadcrumb-item">Airtime</li>
                    <li class="breadcrumb-item active text-primary" aria-current="page">Networks</li>
                  </ol>
                </nav>
              </div>
            </div>
            <!-- end page title -->
          </div>
        </div>
        <!-- end row -->
        <!-- begin row -->
        <div class="row">
          <div class="col-lg-12">
            <div class="card card-statistics">
              <div class="card-body">
                <Loader v-if="$store.getters.isLoading" />
                <div v-else class="export-table-wrapper table-responsive">
                
                
                  <table id="export-table" class="table table-bordered">
                    <thead class="thead-light">
                      <tr>
                        <th>Name</th>
                        <th>Vendor</th>
                        <th>Code</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <span v-if="networks.length < 1">No network found</span>
                      <tr v-for="(network,index) in networks" :key="index">
                        <td>{{network?.name}}</td>
                        <td>{{network?.vendor}}</td>
                        <td>{{network?.code}}</td>
                        <td>
                          <button
                            class="btn btn-secondary mr-5"
                            @click.prevent="editing = true; displayForm(network)"
                          >&#9998;</button>
                        
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end container-fluid -->
    </div>
    <!-- end app-main -->
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      networks: [],
      vendors: [],
      editing: false,
    };
  },
  components: {

  },
  mounted() {
    this.getNetworks();
    this.getVendors();
  },
  methods: {
    getNetworks() {
      this.$store.commit("setLoading", true);
      fetch(this.$store.getters.baseURL + "airtime/networks/all", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$store.getters.getToken
        }
      })
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.networks = result.data.data;
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },
   
    getVendors() {
      fetch(this.$store.getters.baseURL + "app_settings/vendors/airtime", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$store.getters.getToken
        }
      })
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.vendors = result.data;
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },
    async displayForm(network) {
      let networkName = "";
    
      let networkVendor = "";

      if(typeof network !== 'undefined') {
        networkName = network.name;

        networkVendor = network.vendor;
       
      }
      let vendors = network.service_options.map(vendor => {
        return '<option value="' + vendor + '" selected="'+ ( (networkVendor == vendor)? "selected" : "") +'">' + this.capitalize(vendor) + "</option>";
      });

     

    

      const { value: formValues } = await Swal.fire({
        title: (this.editing)? "Edit Network" : "Create Network",
        html:
          '<div class="form-group">' +
          '<input id="name" type="text" placeholder="Name" value="'+ networkName+'" class="swal2-input" autocomplete="off">' +
          "</div>" +
       
          '<div class="form-group">' +
          '<select id="vendor" class="swal2-input" >' +
          '<option value="">Select Vendor</value>' +
          vendors +
          "</select>" +
          "</div>",
        focusConfirm: false,
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: "Submit",
        preConfirm: () => {
          return {
            name: document.getElementById("name").value,
      
            vendor: document.getElementById("vendor").value
          };
        }
      });

      if (formValues) {
        console.log(formValues);
        if(this.editing) {

          this.editNetwork(formValues,network.id);
        }
      }
    },

    editNetwork(formValues,id) {
      this.$store.commit("setLoading", true);
      fetch(this.$store.getters.baseURL + "airtime/networks/"+id+"/update", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$store.getters.getToken
        },
        body: JSON.stringify(formValues)
      })
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            let networkIndex = this.networks.findIndex(network => {
              if(network.id == id) return true;
            });
            this.networks[networkIndex] = result.data;
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
     
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });


    },




    
  }
};
</script>

<style scoped>
</style>